import { createAction } from 'redux-actions'
import Api from '../Api'

import { SAVE_RIDER } from './rider'

export const ADD_RIDER_MEMBER = createAction('ADD_RIDER_MEMBER')
export const REMOVE_RIDER_MEMBER = createAction('REMOVE_RIDER_MEMBER')
export const CREATE_RIDER_MEMBER = createAction('CREATE_RIDER_MEMBER')
export const EDIT_RIDER_MEMBER = createAction('EDIT_RIDER_MEMBER')
export const MOVE_RIDER_MEMBER = createAction('MOVE_RIDER_MEMBER')
export const DELETE_RIDER_MEMBER = createAction('DELETE_RIDER_MEMBER')

export const addRiderMember = (member) => {
  return (dispatch) => dispatch(ADD_RIDER_MEMBER({member}))
}

export const removeRiderMember = (index) => {
  return (dispatch) => dispatch(REMOVE_RIDER_MEMBER({index}))
}

export const createRiderMember = (riderId, member) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(CREATE_RIDER_MEMBER(Api.createRiderMember(riderId, member)))
  }
}

export const editRiderMember = (member) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(EDIT_RIDER_MEMBER(Api.editRiderMember(member)))
  }
}

export const moveRiderMember = (id, position) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(MOVE_RIDER_MEMBER(Api.moveRiderMember(id, position)))
  }
}

export const deleteRiderMember = (member) => {
  return (dispatch) => {
    dispatch(SAVE_RIDER())

    return dispatch(EDIT_RIDER_MEMBER(Api.deleteRiderMember(member)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/rider-member.js